
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.656 11.384V14.3h2.918l8.607-8.608-2.917-2.917-8.608 8.608zM14.429 2.345L12.613.528a.78.78 0 00-1.101 0l-1.424 1.424 2.917 2.917 1.424-1.424a.78.78 0 000-1.1z","fill":"currentColor"}})])
          )
        }
      }
    